<template>
	<div
		:class="[
			'grid',
			space === 'xs' ? 'gap-4 md:gap-8' : '',
			space === 'sm' ? 'gap-8 md:gap-16' : '',
			space === 'md' ? 'gap-12 md:gap-24' : '',
			space === 'lg' ? 'gap-20 md:gap-32' : '',
			columns === 2 ? 'grid-cols-2' : '',
			columns === 3 ? 'grid-cols-3' : '',
			columns === 4 ? 'grid-cols-4' : '',
			columns === 5 ? 'grid-cols-5' : '',
			columns === 6 ? 'grid-cols-6' : '',
			columns === 7 ? 'grid-cols-7' : '',
			columns === 8 ? 'grid-cols-8' : '',
			columns === 9 ? 'grid-cols-9' : '',
			columns === 10 ? 'grid-cols-10' : '',
			columns === 11 ? 'grid-cols-11' : '',
			columns === 12 ? 'grid-cols-12' : '',
			columnsTablet === 2 ? 'md:grid-cols-2' : '',
			columnsTablet === 3 ? 'md:grid-cols-3' : '',
			columnsTablet === 4 ? 'md:grid-cols-4' : '',
			columnsTablet === 5 ? 'md:grid-cols-5' : '',
			columnsTablet === 6 ? 'md:grid-cols-6' : '',
			columnsTablet === 7 ? 'md:grid-cols-7' : '',
			columnsTablet === 8 ? 'md:grid-cols-8' : '',
			columnsTablet === 9 ? 'md:grid-cols-9' : '',
			columnsTablet === 10 ? 'md:grid-cols-10' : '',
			columnsTablet === 11 ? 'md:grid-cols-11' : '',
			columnsTablet === 12 ? 'md:grid-cols-12' : '',
			columnsDesktop === 2 ? 'lg:grid-cols-2' : '',
			columnsDesktop === 3 ? 'lg:grid-cols-3' : '',
			columnsDesktop === 4 ? 'lg:grid-cols-4' : '',
			columnsDesktop === 5 ? 'lg:grid-cols-5' : '',
			columnsDesktop === 6 ? 'lg:grid-cols-6' : '',
			columnsDesktop === 7 ? 'lg:grid-cols-7' : '',
			columnsDesktop === 8 ? 'lg:grid-cols-8' : '',
			columnsDesktop === 9 ? 'lg:grid-cols-9' : '',
			columnsDesktop === 10 ? 'lg:grid-cols-10' : '',
			columnsDesktop === 11 ? 'lg:grid-cols-11' : '',
			columnsDesktop === 12 ? 'lg:grid-cols-12' : '',
		]"
	>
		<slot />
	</div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
	columns: number;
	columnsTablet?: number;
	columnsDesktop?: number;
	space?: 'xs' | 'sm' | 'md' | 'lg';
}>(), {
	space: 'sm',
});
</script>
